import { Fragment, h } from "preact";
import { createPortal } from "preact/compat";
import { useEffect, useState } from "preact/hooks";
import sortBy from "lodash/sortBy";

import FilterPill from "./FilterPill.jsx";
import ModalSelector from "./ModalSelector.jsx";
import NioDropdown from "./NioDropdown.jsx";
import { classNames } from "../helpers.js";

export default function TalentFilter({
  filtered,
  triggerClass,
  name,
  items,
  onChange,
  withPromoted,
  customPromotedSorting,
  noSorting,
  singleSelect,
}) {
  const [filterString, setFilterString] = useState("");
  const count = singleSelect ? 0 : items.filter((item) => item.selected).length;
  const [filteredItems, setFilteredItems] = useState(items);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const needle = filterString.toLowerCase();
    let itemsToShow = noSorting
      ? items
      : sortBy(items, (a) => a.text.toLowerCase());
    if (needle === "" && withPromoted) {
      itemsToShow = items.filter((item) => item.promoted);
      if (!noSorting && customPromotedSorting) {
        itemsToShow = itemsToShow.sort(customPromotedSorting);
      }
    }

    setFilteredItems(
      itemsToShow.filter(
        (item) =>
          (item.text || "").toLowerCase().indexOf(needle) > -1 ||
          (item.description || "").toLowerCase().indexOf(needle) > -1
      )
    );
  }, [items, filterString, withPromoted]);

  function handleFilterChange(value) {
    setFilterString(value);
  }

  const firstSelected = filteredItems.find((item) => item.selected);
  const filterPill = (props) => (
    <FilterPill
      count={!!count && count}
      selected={!singleSelect && firstSelected}
      class={classNames(triggerClass, props.class)}
      onClick={props.onClick}
    >
      {singleSelect && firstSelected ? firstSelected.text : name}
    </FilterPill>
  );

  // TODO: Fix filter logic. Why are there two? here and inside this component.
  return (
    <Fragment>
      <NioDropdown
        class="talent-filter__filter--desktop"
        withFilter={filtered}
        useOwnFilter={true}
        items={filteredItems}
        singleSelect={singleSelect}
        trigger={(getTriggerProps) => (
          <span {...getTriggerProps({}, { suppressRefError: true })}>
            {filterPill({})}
          </span>
        )}
        placeholder={name}
        onSelect={onChange}
        onFilterChange={handleFilterChange}
        closeOnSelect={singleSelect}
      ></NioDropdown>
      {filterPill({
        class: "talent-filter__filter--mobile",
        onClick: () => setShowModal(true),
      })}
      {showModal &&
        createPortal(
          <ModalSelector
            withFilter={filtered}
            useOwnFilter={true}
            items={filteredItems}
            label={name}
            onSelect={onChange}
            onFilterChange={handleFilterChange}
            onClose={() => setShowModal(false)}
          />,
          document.getElementById("modals")
        )}
    </Fragment>
  );
}
